import React from "react";
import { BusinessOperationResponse } from "../../Types/BusinessOperationTypes";
import BaseBusinessResultPage from "../BaseBusinessPageResult";

const BusinessUnenrolmentDetailPageResult: React.FC<{
  response: BusinessOperationResponse;
}> = ({ response }) => <BaseBusinessResultPage response={response} operationType="unenrol" />;

export default BusinessUnenrolmentDetailPageResult;
